(() => {
  const PRODUCT_PATH = '/products/utrecht-wandklok';
  const storefrontPath = window.location.pathname.replace(/^\/[a-z]{2}(?:-[a-z]{2})?(?=\/)/i, '').replace(/\/$/, '');
  if (storefrontPath !== PRODUCT_PATH) return;

  const API_URL = 'https://api-eu.geoapify.com/v1/geocode/search';
  const DEBOUNCE_MS = 450;
  const TIMEOUT_MS = 8000;
  let bootObserver = null;

  const addStyles = () => {
    if (document.getElementById('dc-clock-personalization-styles')) return;
    const style = document.createElement('style');
    style.id = 'dc-clock-personalization-styles';
    style.textContent = `
      domstad-personalization.dc-clock-personalization .dc-clock-fixed-note{margin:-.25rem 0 1.2rem;padding:.8rem .9rem;border-radius:9px;background:rgba(53,88,65,.055);color:rgba(37,55,45,.72);font-size:.76rem;line-height:1.5}
      domstad-personalization.dc-clock-personalization .dc-clock-fixed-note strong{color:#25372d}
      domstad-personalization.dc-clock-personalization .dc-clock-geo-status{margin-top:.4rem;color:rgba(37,55,45,.66);font-size:.7rem;line-height:1.45}
      domstad-personalization.dc-clock-personalization .dc-clock-geo-status[data-state="success"]{color:#355841}
      domstad-personalization.dc-clock-personalization .dc-clock-geo-status[data-state="error"]{color:#8a3c32}
      domstad-personalization.dc-clock-personalization .dc-clock-preview{display:grid;gap:.2rem;min-height:118px;align-content:center}
      domstad-personalization.dc-clock-personalization .dc-clock-preview__fixed,
      domstad-personalization.dc-clock-personalization .dc-clock-preview__coordinates,
      domstad-personalization.dc-clock-personalization .dc-clock-preview__footer{font-family:var(--font-body--family),sans-serif!important;letter-spacing:.04em}
      domstad-personalization.dc-clock-personalization .dc-clock-preview__utrecht{font-size:.78em;font-weight:700;letter-spacing:.18em}
      domstad-personalization.dc-clock-personalization .dc-clock-preview__name{font-size:.72em;line-height:1.12}
      domstad-personalization.dc-clock-personalization .dc-clock-preview__coordinates{font-size:.38em;line-height:1.3}
      domstad-personalization.dc-clock-personalization .dc-clock-preview__footer{font-size:.34em;line-height:1.35;font-weight:600}
      @media screen and (max-width:749px){domstad-personalization.dc-clock-personalization .dc-clock-preview{min-height:104px}}
    `;
    document.head.appendChild(style);
  };

  const formatCoordinates = (lat, lon) => {
    const latNumber = Number(lat);
    const lonNumber = Number(lon);
    if (!Number.isFinite(latNumber) || !Number.isFinite(lonNumber)) return '';
    const latHemisphere = latNumber >= 0 ? 'N' : 'S';
    const lonHemisphere = lonNumber >= 0 ? 'E' : 'W';
    return `${Math.abs(latNumber).toFixed(4)}° ${latHemisphere} | ${Math.abs(lonNumber).toFixed(4)}° ${lonHemisphere}`;
  };

  const getFeatureData = (feature) => {
    if (!feature) return null;
    const props = feature.properties || {};
    const coordinates = Array.isArray(feature.geometry?.coordinates) ? feature.geometry.coordinates : [];
    const lat = props.lat ?? coordinates[1];
    const lon = props.lon ?? coordinates[0];
    const formatted = props.formatted || props.address_line1 || props.name || '';
    const coordinateText = formatCoordinates(lat, lon);
    return coordinateText ? { coordinateText, formatted } : null;
  };

  const ensureHiddenProperty = (form, name, marker) => {
    let input = form.querySelector(`[${marker}]`);
    if (!(input instanceof HTMLInputElement)) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = `properties[${name}]`;
      input.setAttribute(marker, '');
      form.appendChild(input);
    }
    return input;
  };

  function setupBox(box) {
    if (!(box instanceof HTMLElement)) return false;
    if (box.dataset.profile !== 'wandklok') return true;
    if (box.dataset.dcClockReady === 'true') return true;

    const form = box.closest('form');
    const nameInput = box.querySelector('input[name="properties[Naam, namen of familienaam]"]');
    const yearInput = box.querySelector('input[name="properties[Datum]"]');
    const locationInput = box.querySelector('input[name="properties[Adres of locatie voor coördinaten]"]');
    const shortTextInput = box.querySelector('input[name="properties[Korte tekst]"]');
    const preview = box.querySelector('[data-dc-preview]');
    const intro = box.querySelector('.dc-personalization__intro');
    const fields = box.querySelector('.dc-personalization__fields');
    const apiKey = document.querySelector('[data-dc-geoapify-key]')?.dataset.dcGeoapifyKey?.trim() || '';

    if (!(form instanceof HTMLFormElement) || !(nameInput instanceof HTMLInputElement) || !(yearInput instanceof HTMLInputElement) || !(locationInput instanceof HTMLInputElement) || !(preview instanceof HTMLElement) || !(fields instanceof HTMLElement)) return false;

    addStyles();
    box.classList.add('dc-clock-personalization');

    if (intro) intro.textContent = 'UTRECHT blijft vast in het ontwerp. Vul je naam in en voeg eventueel een locatie voor automatisch gevonden coördinaten en een jaartal toe.';

    const yearField = yearInput.closest('.dc-personalization__field');
    const yearLabel = yearField?.querySelector('label');
    if (yearLabel) yearLabel.innerHTML = 'Jaartal <small>optioneel</small>';
    yearInput.name = 'properties[Jaartal]';
    yearInput.placeholder = 'Bijvoorbeeld: 2026';
    yearInput.inputMode = 'numeric';
    yearInput.autocomplete = 'off';
    yearInput.maxLength = 4;
    yearInput.setAttribute('maxlength', '4');
    yearInput.setAttribute('pattern', '[0-9]{4}');
    yearInput.dataset.dcClockYear = '';

    const locationField = locationInput.closest('.dc-personalization__field');
    const locationLabel = locationField?.querySelector('label');
    if (locationLabel) locationLabel.innerHTML = 'Adres of locatie voor coördinaten <small>optioneel</small>';
    locationInput.placeholder = 'Bijvoorbeeld: Domplein 9, Utrecht';
    locationInput.dataset.dcClockLocation = '';
    const oldMetaText = locationField?.querySelector('.dc-personalization__meta span');
    if (oldMetaText) oldMetaText.textContent = 'Vul alleen een adres of locatie in. De coördinaten worden automatisch opgezocht.';

    if (shortTextInput) shortTextInput.closest('.dc-personalization__field')?.remove();

    if (!box.querySelector('.dc-clock-fixed-note')) {
      const note = document.createElement('p');
      note.className = 'dc-clock-fixed-note';
      note.innerHTML = '<strong>Vaste onderdelen:</strong> UTRECHT en DOMTOREN UTRECHT blijven altijd in het ontwerp staan. Een ingevuld jaartal tonen we als SINCE + jaartal.';
      fields.insertAdjacentElement('afterend', note);
    }

    let geoStatus = locationField?.querySelector('[data-dc-clock-geo-status]');
    if (!(geoStatus instanceof HTMLElement) && locationField) {
      geoStatus = document.createElement('p');
      geoStatus.className = 'dc-clock-geo-status';
      geoStatus.setAttribute('data-dc-clock-geo-status', '');
      locationField.appendChild(geoStatus);
    }

    const coordinateProperty = ensureHiddenProperty(form, 'Coördinaten', 'data-dc-clock-coordinate-property');
    const foundLocationProperty = ensureHiddenProperty(form, 'Gevonden locatie', 'data-dc-clock-found-location-property');

    preview.classList.add('dc-clock-preview');
    preview.innerHTML = `
      <div class="dc-clock-preview__fixed dc-clock-preview__utrecht">UTRECHT</div>
      <div class="dc-clock-preview__name" data-dc-preview-line="1">Jouw naam</div>
      <div class="dc-clock-preview__coordinates" data-dc-clock-preview-coordinates></div>
      <div class="dc-clock-preview__footer" data-dc-clock-preview-footer>DOMTOREN UTRECHT</div>
    `;

    const previewCoordinates = preview.querySelector('[data-dc-clock-preview-coordinates]');
    const previewFooter = preview.querySelector('[data-dc-clock-preview-footer]');

    let debounceTimer = null;
    let abortController = null;
    let requestSequence = 0;

    const setStatus = (text, state = '') => {
      if (!geoStatus) return;
      geoStatus.textContent = text;
      if (state) geoStatus.dataset.state = state;
      else delete geoStatus.dataset.state;
    };

    const setResolved = (coordinates = '', foundLocation = '') => {
      coordinateProperty.value = coordinates;
      foundLocationProperty.value = foundLocation;
      if (previewCoordinates) previewCoordinates.textContent = coordinates;
    };

    const updateFooter = () => {
      const year = yearInput.value.trim();
      if (previewFooter) previewFooter.textContent = year.length === 4 ? `SINCE ${year} | DOMTOREN UTRECHT` : 'DOMTOREN UTRECHT';
    };

    const validateYear = () => {
      const year = yearInput.value.trim();
      yearInput.setCustomValidity(year && !/^\d{4}$/.test(year) ? 'Vul een jaartal van 4 cijfers in, bijvoorbeeld 2026.' : '');
      updateFooter();
    };

    const geocode = async () => {
      const query = locationInput.value.trim();
      const sequence = ++requestSequence;
      if (query.length < 3) {
        setResolved('', '');
        setStatus(query ? 'Vul iets meer van het adres of de locatie in.' : '');
        locationInput.setCustomValidity('');
        return;
      }

      if (!apiKey) {
        setResolved('', '');
        setStatus('De automatische locatiezoeker is tijdelijk niet beschikbaar.', 'error');
        locationInput.setCustomValidity('De automatische locatiezoeker is tijdelijk niet beschikbaar.');
        return;
      }

      abortController?.abort();
      abortController = new AbortController();
      const timeout = window.setTimeout(() => abortController?.abort(), TIMEOUT_MS);
      setResolved('', '');
      setStatus('Coördinaten zoeken…');
      locationInput.setCustomValidity('');

      try {
        const url = new URL(API_URL);
        url.searchParams.set('text', query);
        url.searchParams.set('limit', '1');
        url.searchParams.set('lang', 'nl');
        url.searchParams.set('apiKey', apiKey);
        const response = await fetch(url.toString(), { signal: abortController.signal, headers: { Accept: 'application/json' } });
        if (!response.ok) throw new Error(`Geoapify ${response.status}`);
        const data = await response.json();
        if (sequence !== requestSequence) return;
        const result = getFeatureData(data?.features?.[0]);
        if (!result) {
          setStatus('Geen locatie gevonden. Vul bijvoorbeeld straat + plaats of een bekende locatie in.', 'error');
          locationInput.setCustomValidity('We konden deze locatie niet vinden. Controleer het adres of de plaatsnaam.');
          return;
        }
        setResolved(result.coordinateText, result.formatted);
        setStatus(result.formatted ? `Gevonden: ${result.formatted} · ${result.coordinateText}` : `Gevonden: ${result.coordinateText}`, 'success');
        locationInput.setCustomValidity('');
      } catch (error) {
        if (error?.name === 'AbortError' && sequence !== requestSequence) return;
        if (sequence !== requestSequence) return;
        setResolved('', '');
        setStatus(error?.name === 'AbortError' ? 'Het zoeken duurde te lang. Probeer het nog een keer.' : 'De locatie kon niet worden opgezocht. Probeer het opnieuw.', 'error');
        locationInput.setCustomValidity('De locatie kon niet worden opgezocht. Probeer het opnieuw.');
      } finally {
        window.clearTimeout(timeout);
      }
    };

    const scheduleGeocode = () => {
      window.clearTimeout(debounceTimer);
      requestSequence += 1;
      abortController?.abort();
      setResolved('', '');
      locationInput.setCustomValidity('');
      const query = locationInput.value.trim();
      if (!query) {
        setStatus('');
        return;
      }
      setStatus('Wachten op locatie…');
      debounceTimer = window.setTimeout(geocode, DEBOUNCE_MS);
    };

    yearInput.addEventListener('input', () => {
      const cleaned = yearInput.value.replace(/\D/g, '').slice(0, 4);
      if (cleaned !== yearInput.value) yearInput.value = cleaned;
      validateYear();
    });
    yearInput.addEventListener('blur', validateYear);
    locationInput.addEventListener('input', scheduleGeocode);

    const syncActiveState = () => {
      const active = !box.hidden;
      coordinateProperty.disabled = !active;
      foundLocationProperty.disabled = !active;
      if (!active) {
        window.clearTimeout(debounceTimer);
        abortController?.abort();
        requestSequence += 1;
        setResolved('', '');
        setStatus('');
        locationInput.setCustomValidity('');
        yearInput.setCustomValidity('');
      }
    };

    new MutationObserver(syncActiveState).observe(box, { attributes: true, attributeFilter: ['hidden'] });

    form.addEventListener('submit', (event) => {
      if (box.hidden) return;
      validateYear();
      const location = locationInput.value.trim();
      if (location && !coordinateProperty.value.trim()) {
        locationInput.setCustomValidity('Wacht tot de coördinaten zijn gevonden of controleer de ingevoerde locatie.');
      }
      if (!form.checkValidity()) {
        event.preventDefault();
        event.stopImmediatePropagation();
        form.reportValidity();
      }
    }, true);

    validateYear();
    syncActiveState();
    box.dataset.dcClockReady = 'true';
    return true;
  }

  function setupAll(root = document) {
    const boxes = [...root.querySelectorAll?.('domstad-personalization[data-profile="wandklok"]') || []];
    if (!boxes.length) return false;
    return boxes.every(setupBox);
  }

  function start() {
    if (setupAll(document)) return;
    bootObserver = new MutationObserver(() => {
      if (setupAll(document) && bootObserver) bootObserver.disconnect();
    });
    bootObserver.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();

  document.addEventListener('shopify:section:load', (event) => setupAll(event.target));
})();